import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { MovaraMark } from "@/components/Brand";

export function LegalPage({ title, subtitle, updated, children, testId }) {
  return (
    <div className="min-h-screen bg-white" data-testid={testId}>
      {/* Deep terminal blue header */}
      <header className="bg-[#0B132B] text-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <div className="h-14 flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2 font-heading font-black tracking-tight">
              <MovaraMark className="h-5 w-6 text-white" /> MovaRaBoard
            </Link>
            <Link to="/" data-testid="legal-back-link" className="flex items-center gap-1.5 text-[13px] font-semibold text-white/70 hover:text-white transition-colors">
              <ArrowLeft className="h-4 w-4" /> Back to site
            </Link>
          </div>
          <div className="pb-8 pt-4">
            <span className="text-[10px] font-mono font-bold text-[#D97706] tracking-widest uppercase">Legal</span>
            <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tight mt-1">{title}</h1>
            {subtitle && <p className="text-white/60 text-sm mt-2 max-w-2xl">{subtitle}</p>}
            {updated && <p className="text-white/40 text-[12px] font-mono-data mt-3">Last updated: {updated}</p>}
          </div>
        </div>
      </header>

      {/* White canvas body */}
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <div className="space-y-7 text-[15px] leading-relaxed text-ink-2">{children}</div>
        <div className="mt-12 pt-6 border-t border-line flex items-center justify-between">
          <p className="text-[12.5px] text-ink-3 font-mono-data">© 2026 MovaRaBoard</p>
          <a href="mailto:support@movaraboard.com" className="text-[13px] font-semibold text-slate-500 hover:text-[#0B132B] transition-colors">Contact Support</a>
        </div>
      </main>
    </div>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <section>
      <h2 className="font-heading text-lg font-black text-[#0B132B] tracking-tight mb-2">{heading}</h2>
      <div className="space-y-2">{children}</div>
    </section>
  );
}
